import { ExperimentTemplateData } from '@experiment-details/types';
import { generateEmptySection } from '@experiment-management-shared/utils';
import { initializeLayout } from '@experiment-management-shared/utils/layout';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';

export const EMPTY_PERSONAL_TEMPLATE_ID = 'empty_personal_template';

export const EMPTY_EXP_DETAILS_TEMPLATE_DATA = {
  template_name: '',
  template_id: '',
  smoothing: 0,
  x_axis: 'step',
  entire_row_charts: false,
  charts: [],
  outliers: {
    percentile: 0,
    isVisible: true
  },
  panels: {
    isAutoRefreshEnabled: true,
    layout: [],
    panels: [],
    sections: [
      {
        ...generateEmptySection(),
        title: 'Metrics',
        autogenerated: true,
        panels: [],
        layout: initializeLayout({ panels: [], initialLayout: null })
      }
    ],
    version: 5,
    compareXAxis: 'step',
    autoGenerate: false
  },
  autoGeneratedDraft: true,
  deleteAutogenerated: false,
  projectName: '',
  project_id: '',
  metricColors: [],
  metricColorsV2: {
    singleExperiment: {
      isSingleExperimentColor: false,
      colors: [],
      singleExperimentColor: false
    }
  },
  lastUpdate: 0,
  layout: [],
  images: {
    groupBy: false,
    orderBy: 'desc',
    sortBy: 'name'
  },
  audio: {
    groupBy: false,
    orderBy: 'desc',
    sortBy: 'name'
  },
  text: {
    groupBy: false,
    orderBy: 'desc' as const,
    sortBy: 'step',
    fullHeightToggle: false,
    step: -1
  },
  confusionMatrix: {
    assetsIds: [],
    compareAssetsIds: [],
    cellValue: 'Counts',
    colorDistribution: 'Equal'
  },
  histogram: {
    groupBy: false,
    ignoreOutliers: 0.1,
    maxSteps: 50,
    orderBy: 'desc',
    sortBy: 'name'
  },
  metrics: {
    decimalsPrecision: null
  },
  hyperParams: {
    decimalsPrecision: null
  },
  otherParams: {
    decimalsPrecision: null
  },
  transformY: null
};

export const EMPTY_EXP_DETAILS_TEMPLATE = {
  chartTemplate: EMPTY_EXP_DETAILS_TEMPLATE_DATA,
  lastUpdatedAt: 0,
  updatedBy: null,
  personalView: true,
  projectDefault: false,
  projectId: '',
  createdAt: 0,
  templateId: EMPTY_PERSONAL_TEMPLATE_ID,
  templateName: 'Auto Generated',
  projectName: '',
  userName: ''
};

type GeneratePersonalTemplateOpts = {
  projectId: string;
  experimentKey: string;
};
export const generatePersonalTemplate = ({
  projectId,
  experimentKey
}: GeneratePersonalTemplateOpts): ExperimentTemplateData => ({
  chartTemplate: {
    ...EMPTY_EXP_DETAILS_TEMPLATE_DATA,
    experimentKey,
    project_id: projectId,
    template_name: 'Auto Generated',
    autoGeneratedDraft: true,
    template_id: AUTO_GENERATED_OPTION_ID,
    panels: {
      ...EMPTY_EXP_DETAILS_TEMPLATE_DATA.panels,
      autoGenerate: true
    }
  },
  lastUpdatedAt: 0,
  updatedBy: null,
  personalView: true,
  projectDefault: false,
  projectId,
  createdAt: 0,
  templateId: AUTO_GENERATED_OPTION_ID,
  templateName: 'Auto Generated',
  projectName: '',
  userName: ''
});
